// extracted by mini-css-extract-plugin
export default {"Newsletter":"Newsletter_Newsletter__i71Ow"};